module.exports = __webpack_public_path__ + "static/media/Medfacilis-logo.d055d42b.webp";